import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { CartDrawer } from "@/components/CartDrawer";
import Home from "@/pages/Home";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Shop from "@/pages/Shop";
import Attrezzi from "@/pages/Attrezzi";
import ProductPage from "@/pages/ProductPage";
import Portfolio from "@/pages/Portfolio";
import WorkDetail from "@/pages/WorkDetail";
import Contact from "@/pages/Contact";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AuthCallback from "@/components/AuthCallback";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function PublicLayout() {
  return (
    <>
      <Navbar />
      <Outlet />
      <Footer />
      <CartDrawer />
    </>
  );
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route element={<PublicLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/negozio" element={<Shop />} />
        <Route path="/attrezzi" element={<Attrezzi />} />
        <Route path="/negozio/:id" element={<ProductPage />} />
        <Route path="/lavori" element={<Portfolio />} />
        <Route path="/lavori/:id" element={<WorkDetail />} />
        <Route path="/contatti" element={<Contact />} />
        <Route path="/pagamento/riuscito" element={<PaymentSuccess />} />
        <Route path="/pagamento/annullato" element={<PaymentCancel />} />
      </Route>
      <Route path="/admin" element={<AdminDashboard />} />
    </Routes>
  );
}

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, duration: 1.2 }}>
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <ScrollToTop />
            <AppRouter />
          </BrowserRouter>
          <Toaster
            position="bottom-right"
            toastOptions={{
              style: { background: "#1A2F24", color: "#F7F5F0", border: "1px solid #254233", borderRadius: "4px" },
            }}
          />
        </CartProvider>
      </AuthProvider>
    </ReactLenis>
  );
}

export default App;
